<template>
  <li class="splide__slide">
    <slot />
  </li>
</template>

<script>
export default {
  name: 'SplideSlide',
};
</script>
